'use client';

import { User } from '@phosphor-icons/react';

import {
    benefitsId,
    howItWorksId,
    partnersId,
    servicesId,
} from '@/utils/sectionIds';

import type { NavigationConfigType } from '@/components/organisms/Navigation/Navigation.types';

import { env } from '@/env.mjs';

export const NAVIGATION_CONFIG: NavigationConfigType = {
    links: [
        {
            name: 'Dla klientów',
            menu: {
                lead: {
                    name: 'PayPo dla klientów',
                    href: '/',
                    dataTestId: 'main-nav-homepage-link',
                },
                list: [
                    {
                        name: 'Jak to działa?',
                        relatedSectionId: howItWorksId,
                        href: `/#${howItWorksId}`,
                        dataTestId: 'main-nav-how-it-works-link',
                    },
                    {
                        name: 'Usługi PayPo',
                        relatedSectionId: servicesId,
                        href: `/#${servicesId}`,
                        dataTestId: 'main-nav-services-ref',
                    },
                    {
                        name: 'Korzyści',
                        relatedSectionId: benefitsId,
                        href: `/#${benefitsId}`,
                        dataTestId: 'main-nav-benefits-link',
                    },
                    {
                        name: 'Promocje',
                        relatedSectionId: partnersId,
                        href: `/#${partnersId}`,
                        dataTestId: 'main-nav-partners-link',
                    },
                    {
                        name: 'Kontakt',
                        href: '/p/kontakt',
                        dataTestId: 'main-nav-contact-link',
                    },
                ],
            },
        },
        {
            name: 'Dla sklepów',
            menu: {
                lead: {
                    name: 'PayPo dla sklepów',
                    href: `${env.NEXT_PUBLIC_BUSINESS_URL}/biznes`,
                    dataTestId: 'main-nav-business-page-link',
                },
                list: [
                    {
                        name: 'Korzyści',
                        href: `${env.NEXT_PUBLIC_BUSINESS_URL}/biznes#start-sell`,
                        dataTestId: 'main-nav-business-benefits-link',
                    },
                    {
                        name: 'Jak to działa?',
                        href: `${env.NEXT_PUBLIC_BUSINESS_URL}/biznes#how-it-works`,
                        dataTestId: 'main-nav-business-how-it-works-link',
                    },
                    {
                        name: 'Dlaczego warto?',
                        href: `${env.NEXT_PUBLIC_BUSINESS_URL}/biznes#why-worth`,
                        dataTestId: 'main-nav-business-why-worth-link',
                    },
                    {
                        name: 'Integracja',
                        href: `${env.NEXT_PUBLIC_BUSINESS_URL}/biznes/integracja`,
                        dataTestId: 'main-nav-business-integration-link',
                    },
                    {
                        name: 'Kontakt',
                        href: `${env.NEXT_PUBLIC_BUSINESS_URL}/biznes/kontakt`,
                        dataTestId: 'main-nav-business-contact-link',
                    },
                ],
            },
        },
        {
            name: 'Dostępne sklepy',
            href: '/p/dostepnesklepy/',
            dataTestId: 'main-nav-available-shops-page-link',
        },
        {
            name: 'Płać z aplikacją',
            href: '/p/plac-z-aplikacja/',
            dataTestId: 'main-nav-pay-with-app-page-link',
        },
        {
            name: 'Kontakt',
            href: '/p/kontakt/',
            dataTestId: 'main-nav-contact-page-link',
        },
    ],
    buttons: [
        {
            children: 'Zaloguj się',
            href: `${env.NEXT_PUBLIC_WWW_URL}/home/zaloguj`,
            variant: 'outline',
            size: 'm',
            dataTestId: 'main-nav-login-page-button',
            className: 'text-nowrap',
        },
        {
            children: 'Załóż konto',
            size: 'm',
            href: `${env.NEXT_PUBLIC_PANEL_URL}/registration`,
            dataTestId: 'main-nav-registration-page-button',
            className: 'text-nowrap',
        },
    ],
    mobileControls: [
        {
            href: `${env.NEXT_PUBLIC_WWW_URL}/home/zaloguj`,
            icon: <User weight="bold" />,
            ariaLabel: 'Przejdź do strony logowania',
        },
    ],
};
